import { createActionType } from "../../../../_shared/utils";
import { ActionOption } from "../../../types";

export const GET_WHITELIST = createActionType("GET_WHITELIST", "WHITELIST");

export const getWhitelist = (id: string, options?: ActionOption) => ({
  type: GET_WHITELIST.START,
  meta: {
    ...options,
    id,
  },
});
